import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useAuthContext } from '@/contexts/AuthContext';
import { AuthForm, AuthMode } from '@/components/auth/AuthForm';

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export const LoginModal: React.FC<LoginModalProps> = ({ isOpen, onClose, onSuccess }) => {
  const [mode, setMode] = useState<AuthMode>('login');
  const { login } = useAuthContext();

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setMode('login');
      onClose();
    }
  };

  const handleSuccess = (token: string, user: any) => {
    login(token, user);
    setMode('login');
    onClose();
    if (onSuccess) onSuccess();
  };

  const title =
    mode === 'login' ? 'Sign in.' :
    mode === 'register' ? 'Make an account.' :
    'Reset password.';
  const subtitle =
    mode === 'login' ? '' :
    mode === 'register' ? 'Free account. Start using the tools in under a minute.' :
    "We'll email you a link to set a new password.";

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent
        className="sm:max-w-md"
        style={{
          background: 'var(--hj-surface-1)',
          border: '1px solid var(--hj-hairline)',
          color: 'var(--hj-ink)',
        }}
      >
        <DialogHeader className="text-center" style={{ gap: 10 }}>
          <div className="flex justify-center">
            <img
              src="/brand/wordmark-heyjoe.png"
              alt="Hey Joe"
              className="h-10 w-auto dark:[filter:invert(96%)_sepia(8%)_saturate(280%)_hue-rotate(345deg)_brightness(102%)]"
            />
          </div>
          <DialogTitle asChild>
            <h2
              className="font-hj-display m-0 text-center"
              style={{
                fontSize: 30,
                color: 'var(--hj-ink)',
                letterSpacing: '-0.03em',
                fontWeight: 800,
                marginTop: 14,
              }}
            >
              {title}
            </h2>
          </DialogTitle>
          <DialogDescription asChild>
            <p
              className="m-0 text-center"
              style={{ fontSize: 13.5, color: 'var(--hj-ink-3)', lineHeight: 1.5, marginTop: 4 }}
            >
              {subtitle}
            </p>
          </DialogDescription>
        </DialogHeader>

        <AuthForm
          mode={mode}
          onModeChange={setMode}
          onSuccess={handleSuccess}
          showCancel
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};
